module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer ai-c jc-sb m-jc-fs m-fd-r",
    attrs: {
      "id": "menuHeaderAdmin"
    }
  }, [_c('h1', {
    staticClass: "titleSandBox"
  }, [_vm._v("SANDBOX")]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer jc-sb ai-c ac-c linksWrapper mobileNot center"
  }, [_c('h3', {
    staticClass: "message txtCenter"
  }, [_vm._v(_vm._s(_vm.$t("sandbox.message")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b217343c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/HeaderSandBox.vue
// module id = 3346
// module chunks = 0